export default "__VITE_ASSET__CEoa302H__"